<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mt-4">
            <div class="row mt-2">
              <!-- 1. Einzelcoaching -->
              <CoachingButton
                  :enabled="companySettings.privateCoachingEnabled"
                  route-name="privateCoachingNewAndActiveList"
                  coaching-type="private"
                  label="Einzelcoaching"/>

              <!-- 2. Gruppenmaßnahmen -->
              <CoachingButton
                  :enabled="companySettings.groupCoachingEnabled"
                  route-name="groupCoachingNewAndActiveList"
                  icon="fa-users"
                  coaching-type="group"
                  label="Gruppenmaßnahmen"/>

              <!-- 3. Soziotherapie -->
              <CoachingButton
                  :enabled="companySettings.socioTherapyCoachingEnabled"
                  route-name="socioTherapyCoachingNewAndActiveList"
                  icon="fa-hand-holding-heart"
                  coaching-type="socioTherapy"
                  label="Soziotherapie"/>

              <!-- 4. Betreutes Wohnen -->
              <CoachingButton
                  :enabled="companySettings.assistedLivingCoachingEnabled"
                  route-name="assistedLivingCoachingNewAndActiveList"
                  icon="fa-house-chimney-user"
                  coaching-type="assistedLiving"
                  label="Betreutes Wohnen"/>

              <!-- 5. DRV Fallmanagement -->
              <CoachingButton
                  :enabled="companySettings.caseManagementCoachingEnabled"
                  route-name="caseManagementCoachingNewAndActiveList"
                  icon="fa-briefcase"
                  coaching-type="caseManagement"
                  label="DRV Fallmanagement"/>

              <!-- 6. Private Weiterbildung -->
              <CoachingButton
                  :enabled="companySettings.privateLearningCoachingEnabled"
                  route-name="privateLearningCoachingNewAndActiveList"
                  icon="fa-graduation-cap"
                  coaching-type="privateLearning"
                  label="Private Weiterbildung"/>
            </div>
          </div>

          <h6 class="mt-5">{{ $t('general.active_customers') }}</h6>
          <div class="row g-4 mt-1">
            <!-- 1. Einzelcoaching -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.privateCoachingEnabled">
              <CoachingCardInfo
                  label="Einzelcoaching"
                  type="private"
                  :value="infoData?.countActiveCoaching?.counts?.privateCoaching"
              />
            </div>

            <!-- 2. Gruppenmaßnahmen -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.groupCoachingEnabled">
              <CoachingCardInfo
                  label="Gr.-Maßnahmen"
                  type="group"
                  :value="infoData?.countActiveCoaching?.counts?.groupCoaching"
              />
            </div>

            <!-- 3. Soziotherapie -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.socioTherapyCoachingEnabled">
              <CoachingCardInfo
                  label="Soziotherapie"
                  type="socioTherapy"
                  :value="infoData?.countActiveCoaching?.counts?.socioTherapyCoaching"
              />
            </div>

            <!-- 4. Private Weiterbildung -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.privateLearningCoachingEnabled">
              <CoachingCardInfo
                  label="Private Weiterbildung"
                  type="privateLearning"
                  :value="countPrivateLearningCoaching"
              />
            </div>

            <!-- 5. DRV Fallmanagement -->
            <div class="col-lg-3 col-md-6 col-sm-12"
                 v-if="companySettings?.caseManagementCoachingEnabled">
              <CoachingCardInfo
                  label="DRV Fallmanagement"
                  type="caseManagement"
                  :value="infoData?.countActiveCoaching?.counts?.caseManagementCoaching"
              />
            </div>
          </div>

          <div v-if="companySettings?.assistedLivingCoachingEnabled" class="mt-4">
            <!-- Elegantan i čist podnaslov sekcije -->
            <h6 class="section-subtitle mb-3">
              Betreutes Wohnen
            </h6>

            <!-- Row sa g-4 klasom za savršen razmak između kartica -->
            <div class="row g-4">
              <!-- 1. Betreutes Wohnen (Klijenti) -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Betreutes Wohnen"
                    type="assistedLiving"
                    :value="countAssistedLivingCoaching"
                />
              </div>

              <!-- 2. Summe FLS pro Woche (Sedmične jedinice) -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Summe FLS pro Woche"
                    type="weeklySum"
                    :value="infoData?.sumUnitsInWeekForAlCoaching"
                />
              </div>
            </div>
          </div>

          <div v-if="companySettings?.locationEnabled" class="mt-4">
            <!-- Elegantan podnaslov sa ikonicom mape -->
            <h6 class="section-subtitle mb-3">
              Übersicht Standorte
            </h6>

            <div class="row g-4">
              <!-- 1. Interne Standorte -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Interne Standorte"
                    type="internalLocation"
                    :value="infoData?.countInternalOffices"
                />
              </div>

              <!-- 2. Externe Standorte -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Externe Standorte"
                    type="externalLocation"
                    :value="infoData?.countExternalOffices"
                />
              </div>

              <!-- 3. Sonstige Standorte -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Sonstige Standorte"
                    type="otherLocation"
                    :value="infoData?.countOtherOffices"
                />
              </div>
            </div>
          </div>

          <div v-if="companySettings?.userEnabled" class="mt-4">
            <!-- Elegantan podnaslov sa ikonicom zaposlenika -->
            <h6 class="section-subtitle mb-3">
              Übersicht Mitarbeiter
            </h6>

            <div class="row g-4">
              <!-- 1. Interne Mitarbeiter -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Interne Mitarbeiter"
                    type="internalUser"
                    :value="infoData?.countInternalUsers"
                />
              </div>

              <!-- 2. Externe Mitarbeiter -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Externe Mitarbeiter"
                    type="externalUser"
                    :value="infoData?.countExternalUsers"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar
          </h6>
        </template>

        <div class="element-box mt-2">
          <h6>{{ $t('general.active_customers') }}</h6>
          <VueApexCharts
              :key="seriesActiveCoach.length"
              width="100%"
              type="donut"
              :options="chartOptions"
              :series="seriesActiveCoach"/>
        </div>
        <div class="element-box mt-2">
          <div class="mt-3" v-if="infoData?.jubileesOfEmployees?.length">
            <Anniversary :jubilees="infoData?.jubileesOfEmployees" />
          </div>
        </div>

        <div class="element-box mt-2">
          <div class="mt-3" v-if="infoData?.todayBirthdays?.length">
            <Birthday :birthdays="infoData?.todayBirthdays" />
          </div>
        </div>
      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import dashboardAdminService from '@/api/Dashboard/Admin';
import FormSidebar from '@/components/FormSidebar.vue';
import {ErrorToast} from '@/components/VueToast';
import {getDonutColorsByCompany, optionsChartDonut} from '@/shared/utils/apex';
import {piniaUserStore} from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/Admin/Menu.vue';
import {computed, onMounted, ref} from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import CoachingButton from "@/components/button/CoachingButton.vue";
import CoachingCardInfo from "@/components/card/CoachingCardInfo.vue";
import Anniversary from "@/components/Anniversary.vue";
import Birthday from "@/components/Birthday.vue";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

const chartOptions = ref(optionsChartDonut);
const seriesActiveCoach = ref([]);
const infoData = ref({});

async function getInfoData() {
  try {
    const {data} = await dashboardAdminService.getInfoData();
    infoData.value = data.data;


    const countActiveCoachingTotal =
        data.data.countActiveCoaching?.total +
        infoData?.value?.countNewCoaching?.counts?.privateLearningCoaching +
        infoData?.value?.countNewCoaching?.counts?.assistedLivingCoaching;

    seriesActiveCoach.value = Object.values(data.data.countActiveCoaching?.counts);
    chartOptions.value = {
      ...chartOptions.value,
      colors: getDonutColorsByCompany(companySettings.value?.companyKey),
      labels: [
        `Einzelcoaching ${data.data.countActiveCoaching.counts?.privateCoaching}`,
        `Gruppenmaßnahmen ${data.data.countActiveCoaching.counts?.groupCoaching}`,
        `Soziotherapie ${data.data.countActiveCoaching.counts?.socioTherapyCoaching}`,
        `Private Weiterbildung ${countPrivateLearningCoaching.value}`,
        `Betreutes Wohnen ${countAssistedLivingCoaching.value}`,
        `DRV Fallmanagement ${data.data.countActiveCoaching.counts?.caseManagementCoaching}`,
      ],

      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'left',
        fontSize: '11px',          // Reduced font size from 14px to a small and elegant 11px
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        textColor: '#64748b',      // Neutral gray that matches the sidebar

        // Pack elements tightly to save vertical space
        itemMargin: {
          horizontal: 6,           // Reduced horizontal spacing between items
          vertical: 2              // Minimal spacing between legend rows
        },

        // More discrete, smaller color markers
        markers: {
          width: 8,                // Marker diameter reduced to 8px (more discrete)
          height: 8,
          radius: 12,              // Makes them perfectly round
          offsetX: -3
        }
      },

      plotOptions: {
        pie: {
          donut: {
            ...chartOptions.value.plotOptions.pie.donut,
            labels: {
              ...chartOptions.value.plotOptions.pie.donut.labels,
              total: {
                ...chartOptions.value.plotOptions.pie.donut.labels.total,
                formatter: () => countActiveCoachingTotal.toString(),
              },
            },
          },
        },
      },
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

const countPrivateLearningCoaching = computed(() =>
    (infoData?.value?.countActiveCoaching?.counts?.privateLearningCoaching ?? 0) +
    (infoData?.value?.countNewCoaching?.counts?.privateLearningCoaching ?? 0),
);

const countAssistedLivingCoaching = computed(() =>
    (infoData?.value?.countActiveCoaching?.counts?.assistedLivingCoaching ?? 0) +
    (infoData?.value?.countNewCoaching?.counts?.assistedLivingCoaching ?? 0),
);

onMounted(() => {
  getInfoData();
});

</script>

<style scoped>

</style>